export default __webpack_public_path__ + "static/media/E16.63f984fe.jpg";